module.exports = __webpack_public_path__ + "static/media/orders.ce3ee467.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/orders.png
// module id = 35
// module chunks = 0